// @flow
import { createSelector } from "reselect";
import { selectIsShowing } from "root/selectors";

const getCameraData = (state: Object) => state.camera;

const selectTabData: Object => Object = createSelector(
	selectIsShowing,
	getCameraData,
	(isWidgetShowing, data) => ({
		isAllowed: data.cameraAllowed,
		isLoading: data.cameraLoading,
		notFound: data.cameraNotFound,
		isWidgetShowing,
	}),
);

export {
	selectTabData,
};
